import type { UserList } from 'models';
import type { ReactNode } from 'react';
import { routes } from 'routes/routes';
import { Link } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { UserPopover } from 'features/users/components/user-popover';

type P = {
  author: UserList;
  children: ReactNode;
};

const ContentObjectAuthor = ({ author, children }: P) => (
  <UserPopover user={author}>
    <Link effects={{ focus: true, hover: true, radius: true }} to={routes.members.detail(author.id)}>
      {children}
    </Link>
  </UserPopover>
);

export default ContentObjectAuthor;
